module.exports = __webpack_public_path__ + "static/img/headImg.1cabd572.png";